import { withBlockExtensions } from '@plone/volto/helpers/Extensions';

import LinkMapBody from './LinkMapBody';

const LinkMapView = (props) => <LinkMapBody {...props} />;

export default withBlockExtensions(LinkMapView);
